<div class="error-generic">
    <div class="error-container">
        <div class="content-container">
            <p class="message-error">Error en la carga del widget</p>
        </div>
    </div>
</div>
